import theme from '@style';
import Text from '@basicComponents/text';
import React from 'react';
import {Animated, KeyboardAvoidingView, View} from 'react-native';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import {
  replace,
  goBack,
  goTo,
  navigationRef,
  useResponsiveDimensions,
} from '@/utils';
import LinearGradient from '@basicComponents/linear-gradient';
import {ScrollView} from 'react-native-gesture-handler';
import Button from '@basicComponents/button';
import globalStore from '@/services/global.state';
import {passwordLogin, userLogin} from './login.service';
import {styles} from './login.style';
import CodeInput from './components/code-input';
import PhoneInput from './components/phone-input';
import NavTitle from '@basicComponents/nav-title';
import AccountTip from './components/account-tip';
import {BasicObject, NavigatorScreenProps} from '@/types';
import {setScratchAuth} from '@/services/global.service';
import {useTranslation} from 'react-i18next';
import baseVariable from '@/style/base.variable';
import {toChat} from '../game-navigate';
import {postUserInfo} from '@/services/global.service';
import {postReport, TReportType, TSourceType} from '@/services/global.service';

import {flex} from '@/components/style';
import {clearAllWin} from '@/components/utils/gameWin';
import {apiSendPhoneCode, defaultPhoneCode, homePage} from '@/config';
// const icon = require('../../assets/icons/login/login-botttom.webp');
const Login = (props: NavigatorScreenProps) => {
  const {i18n} = useTranslation();
  /** 确认来源页，有些页面需要调用方法，如chat */
  const fromPage =
    ((props.route.params as BasicObject)?.fromPage as string) || null;
  /** 直接返回的目标页面,避免原页面加载就需要token */
  const backPage =
    ((props.route.params as BasicObject)?.backPage as string) || null;
  /** 登录成功的目标页面,回到原页面操作,这个是用来传递给注册页面的,登录页面成功直接返回  */
  const sucessPage =
    ((props.route.params as BasicObject)?.sucessPage as string) || null;
  /** 登录成功的目标页面,回到原页面操作 */
  const sucessPageParams =
    ((props.route.params as BasicObject)?.sucessPageParams as BasicObject) ||
    null;
  const [switchIndex, setSwitchIndex] = React.useState(0);
  const switchBgLeftValue = React.useRef(new Animated.Value(0)).current;
  const [userPhone, setUserPhone] = React.useState('');
  const [userPhoneCode, setUserPhoneCode] = React.useState(defaultPhoneCode);
  const [OTPCode, setOTPCode] = React.useState('');
  const [userPassword, setUserPassword] = React.useState('');

  const setValueOrCode = (value: string) => {
    switchIndex === 1 ? setOTPCode(value) : setUserPassword(value);
  };
  React.useEffect(() => {
    globalStore.removeItem('scratchToken');
    globalStore.removeItem('scratchUrl');
    globalStore.token = null;
    globalStore.userInfo = null;
  }, []);
  const forgotBoxAnimation = React.useRef(new Animated.Value(0)).current;
  const forgotBoxOpcity = forgotBoxAnimation.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 1],
  });
  const forgotTrans = forgotBoxAnimation.interpolate({
    inputRange: [0, 1],
    outputRange: [(theme.paddingSize.m + 18) * -1, 0],
  });
  const {width} = useResponsiveDimensions();
  React.useEffect(() => {
    setUserPassword('');
    setOTPCode('');

    requestAnimationFrame(() => {
      Animated.timing(switchBgLeftValue, {
        toValue: (switchIndex * (width - 4 * theme.paddingSize.l)) / 2,
        duration: 300,
        useNativeDriver: true,
      }).start();
      Animated.timing(forgotBoxAnimation, {
        toValue: 1 - switchIndex,
        duration: 300,
        useNativeDriver: true,
      }).start();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [switchIndex, width]);

  const handleForgotPassword = () => {
    goTo('ForgotPassword', {
      sucessPage,
      sucessPageParams,
    });
  };
  return (
    <KeyboardAvoidingView
      behavior="height"
      style={[
        theme.fill.fill,
        theme.flex.col,
        theme.background.white,
        theme.position.rel,
      ]}>
      <ScrollView keyboardShouldPersistTaps="always" style={[flex.flex1]}>
        <LinearGradient colors={['#212329', '#16181B']}>
          <NavTitle
            onClose={() => {
              if (
                globalStore.isWeb &&
                (!navigationRef.current ||
                  navigationRef.current.getState().routes.length < 2)
              ) {
                // 如果web进来,只有一层路由,直接到首页
                goTo(homePage);
                return;
              }
              if (backPage) {
                goTo(backPage);
              } else {
                goBack();
              }
            }}
            title={i18n.t('login.label.login')}
          />
        </LinearGradient>

        <View
          style={[
            {
              padding: theme.paddingSize.l * 2,
            },
          ]}>
          <View style={[theme.flex.row, theme.position.rel, theme.margin.btmm]}>
            <Animated.View
              style={[
                styles.switchBgStyle,
                {
                  transform: [
                    {
                      translateX: switchBgLeftValue,
                    },
                  ],
                },
              ]}>
              <LinearGradient
                style={[theme.fill.fill]}
                start={{x: 1, y: 1}}
                end={{x: 1, y: 0}}
                colors={baseVariable.basicColor.loginLinearGradient}
              />
            </Animated.View>
            {['login.label.password-login', 'login.label.otp-login'].map(
              (v, i) => (
                <NativeTouchableOpacity
                  key={i}
                  onPress={() => setSwitchIndex(i)}
                  style={[
                    theme.flex.flex1,
                    theme.flex.center,
                    theme.padding.tbxxl,
                    theme.padding.lrl,
                  ]}>
                  <Text
                    style={[
                      theme.font.fm,
                      theme.font.bold,
                      {color: i !== switchIndex ? 'var(--T3)' : 'var(--T1)'},
                    ]}>
                    {i18n.t(v)}
                  </Text>
                </NativeTouchableOpacity>
              ),
            )}
          </View>
          <PhoneInput
            userPhone={userPhone}
            setUserPhone={setUserPhone}
            userPhoneCode={userPhoneCode}
            setUserPhoneCode={setUserPhoneCode}
          />
          <View style={styles.interval} />
          <CodeInput
            setValueOrCode={setValueOrCode}
            switchIndex={switchIndex ? 1 : 0}
            userPhone={userPhone}
            userPhoneCode={userPhoneCode}
            OTPCode={OTPCode}
            userPassword={userPassword}
          />
          <Animated.View
            style={[
              {
                opacity: forgotBoxOpcity,
                transform: [{scaleY: forgotBoxOpcity}],
              },
              theme.overflow.hidden,
            ]}>
            <NativeTouchableOpacity
              style={[theme.margin.topm, theme.padding.topm]}
              onPress={handleForgotPassword}>
              <Text
                size="medium"
                textAlign="center"
                color={theme.basicColor.primary}>
                {i18n.t('login.tip.forgot')}
              </Text>
            </NativeTouchableOpacity>
          </Animated.View>
          <Animated.View
            style={[
              {
                transform: [{translateY: forgotTrans}],
              },
            ]}>
            <View
              style={{
                marginVertical: theme.paddingSize.m * 2,
              }}>
              <Button
                buttonStyle={[styles.loginButton, theme.overflow.hidden]}
                onPress={() => {
                  if (userPhone === '') {
                    globalStore.globalWaringTotal(i18n.t('login.tip.no-phone'));
                    return;
                  }
                  if (switchIndex === 1 && OTPCode === '') {
                    globalStore.globalWaringTotal(i18n.t('login.tip.no-otp'));
                    return;
                  }
                  if (switchIndex === 0 && userPassword === '') {
                    globalStore.globalWaringTotal(
                      i18n.t('login.tip.no-password'),
                    );
                    return;
                  }
                  globalStore.globalLoading.next(true);
                  (switchIndex === 1
                    ? userLogin(
                        (apiSendPhoneCode ? userPhoneCode : '') + userPhone,
                        OTPCode,
                      )
                    : passwordLogin(
                        (apiSendPhoneCode ? userPhoneCode : '') + userPhone,
                        userPassword,
                      )
                  )
                    .then(async res => {
                      if (
                        switchIndex === 1 &&
                        (res as {token: string; isNewUser: boolean}).isNewUser
                      ) {
                        postReport({
                          reportType: TReportType.REGISTER,
                          sourceType:
                            localStorage.getItem('from') === 'im'
                              ? TSourceType.IM
                              : TSourceType.CHANNEL,
                        }).then(_ => localStorage.removeItem('from'));
                      }
                      if (typeof res === 'string') {
                        globalStore.token = res;
                      } else {
                        globalStore.token = res.token;
                      }
                      const userInfo = await postUserInfo();
                      globalStore.userInfo = userInfo;
                      setScratchAuth(
                        () => {},
                        () => {
                          if (sucessPage) {
                            replace(sucessPage, sucessPageParams);
                          } else if (
                            !navigationRef.current ||
                            navigationRef.current.getState().routes.length < 2
                          ) {
                            replace(homePage, {screen: 'Home'});
                          } else {
                            if (fromPage === 'chat') {
                              toChat();
                            } else {
                              goBack();
                            }
                          }
                          globalStore.globalLoading.next(false);
                        },
                      );
                      clearAllWin().then();
                    })
                    .catch(() => {
                      globalStore.globalLoading.next(false);
                    });
                }}
                disabled={
                  switchIndex === 0
                    ? userPassword.length < 6
                    : OTPCode.length !== 6
                }
                type="linear-primary"
                color={theme.basicColor.white}
                titleBold>
                <Text
                  fontFamily="fontInter"
                  fontSize={14}
                  letterSpacing={0}
                  blod
                  style={'#fff' as any}>
                  {i18n.t('login.label.login')}
                </Text>
              </Button>
            </View>
            <AccountTip
              tip="login.tip.new-account"
              linkTip="login.tip.sing-in"
              onPressLink={() => {
                const data: BasicObject = {};
                if (backPage) {
                  data.backPage = backPage;
                }
                if (sucessPage) {
                  data.sucessPage = sucessPage;
                }
                if (sucessPageParams) {
                  data.sucessPageParams = sucessPageParams;
                }
                goTo('SingUp', data);
              }}
            />
          </Animated.View>
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
};

export default Login;
